var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    [
      _c(
        "div",
        { attrs: { slot: "header" }, slot: "header" },
        [
          _c(
            "el-row",
            {
              staticStyle: { "margin-bottom": "0" },
              attrs: { type: "flex", justify: "space-between" }
            },
            [
              _c("h3", [
                _vm._v("Einstellungen für "),
                _vm.supplierName
                  ? _c("span", [_vm._v(_vm._s(_vm.supplierName))])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "text" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("canceled")
                    }
                  }
                },
                [_vm._v("Schliessen")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.supplierSettings
        ? _c(
            "el-form",
            {
              ref: "supplierSettings",
              attrs: {
                model: _vm.supplierSettings,
                "label-width": "300px",
                "label-position": "left"
              }
            },
            [
              _vm._l(
                Object.keys(Object.assign({}, _vm.supplierSettings)).filter(
                  function(key) {
                    return key !== "supplier_id"
                  }
                ),
                function(key) {
                  return _c(
                    "el-form-item",
                    {
                      key: key,
                      attrs: { label: _vm.parseLabel(key), prop: key }
                    },
                    [
                      key !== "supplier_id" && key !== "order_additonal_field"
                        ? _c(
                            "el-input",
                            {
                              model: {
                                value: _vm.supplierSettings[key],
                                callback: function($$v) {
                                  _vm.$set(_vm.supplierSettings, key, $$v)
                                },
                                expression: "supplierSettings[key]"
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(key) +
                                  "\n            "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      key === "order_additonal_field"
                        ? _c(
                            "div",
                            [
                              _vm._l(_vm.orderAdditionalOptions, function(tag) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: tag,
                                    attrs: {
                                      closable: "",
                                      "disable-transitions": false
                                    },
                                    on: {
                                      close: function($event) {
                                        return _vm.handleDeleteOption(tag)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(tag) +
                                        "\n                "
                                    )
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _vm.newOptionVisible
                                ? _c("el-input", {
                                    ref: "saveNewOptionInput",
                                    refInFor: true,
                                    staticClass: "input-new-tag",
                                    attrs: { size: "mini" },
                                    on: { blur: _vm.handleCreateOption },
                                    nativeOn: {
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.handleCreateOption.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.newOptionValue,
                                      callback: function($$v) {
                                        _vm.newOptionValue = $$v
                                      },
                                      expression: "newOptionValue"
                                    }
                                  })
                                : _c(
                                    "el-button",
                                    {
                                      staticClass: "button-new-tag",
                                      attrs: { size: "small" },
                                      on: { click: _vm.showNewOption }
                                    },
                                    [_vm._v("+ New Tag")]
                                  )
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  )
                }
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { disabled: _vm.loading, type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitForm("supplierSettings")
                        }
                      }
                    },
                    [_vm._v("Bestätigen\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { disabled: _vm.loading },
                      on: {
                        click: function($event) {
                          return _vm.$emit("canceled")
                        }
                      }
                    },
                    [_vm._v("Abbrechen\n            ")]
                  )
                ],
                1
              )
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-189b4b6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-189b4b6c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/suppliers/SettingsForm.vue
// module id = null
// module chunks = 